export default __webpack_public_path__ + "static/media/beaver.ac5fe376.svg";